export default __webpack_public_path__ + "static/media/28.5fdf9f0f.pdf";